/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Rule_OutbidInputs */

const en_directory_vibebids_rule_outbid = /** @type {(inputs: Directory_Vibebids_Rule_OutbidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beat the current bid by $1 to take the rank.`)
};

const zh_directory_vibebids_rule_outbid = /** @type {(inputs: Directory_Vibebids_Rule_OutbidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比当前出价多 1 美元即可拿下该排名。`)
};

/**
* | output |
* | --- |
* | "Beat the current bid by $1 to take the rank." |
*
* @param {Directory_Vibebids_Rule_OutbidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_rule_outbid = /** @type {((inputs?: Directory_Vibebids_Rule_OutbidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Rule_OutbidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_rule_outbid(inputs)
	return zh_directory_vibebids_rule_outbid(inputs)
});
export { directory_vibebids_rule_outbid as "directory.vibebids.rule_outbid" }